<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="700"
    [nzVisible]="isVisibleUnderReviewDrawer" [nzTitle]="underReviewDrawerTitle" [nzFooter]="footerTpl"
    (nzOnClose)="handleCancel()">
    <form nz-form *nzDrawerContent [formGroup]="_fS.underReviewForm">
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="nameError">
                        <label class="label-text required">Reason</label>
                        <input type="text" pattern="^(?!\s+$).+" 
                            class="input-group" nz-input formControlName="reason" maxlength="50" minlength="2">
                        <ng-template #nameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter reason</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Reason {{validationMessage.minlength}}</ng-container>
                            <ng-container *ngIf="control.hasError('maxlength')">Please enter upto 50 characters</ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter valid reason</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="15">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="colorError">
                        <label class="label-text required">Color</label>
                        <nz-select nzShowSearch nzPlaceHolder="Select color" [nzSize]="'default'"
                                formControlName="color" [nzSelectOnTab]="true">
                                <nz-option [nzLabel]="'Red'" [nzValue]="'Red'"></nz-option>
                                <nz-option [nzLabel]="'Gray'" [nzValue]="'Gray'"></nz-option>
                            </nz-select>
                        <!-- <div class=" d-flex align-i-c">
                            <div class="color picker-box d-flex align-i-c"
                                [ngStyle]="{'border': this.lightColorValidationColor=='INVALID' ? '1px solid red' : ''}">
                                <span class="color-name" [ngStyle]="{'background-color':lightColorStyle}"></span>
                                <input class="input-group color-input" nz-input formControlName="color"
                                    type="color" [(ngModel)]="lightColorStyle" (Change)="applyColorlightColor()" />
                                <span class="color-picker-icon"><img src="assets/images/color-picker-icon .svg"></span>
                            </div>
                        </div> -->
                        <ng-template #colorError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please select color</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="15">
             <div nz-col nzSpan="24">
                <nz-form-item>
                    <div>
                    <nz-form-control [nzErrorTip]="emailCopyErr">
                        <div class="d-flex"><label class="label-text">Email Copy</label>
                            <!-- <span nz-icon nzType="fullscreen" nzTheme="outline" (click)="openInFullScreen()" class="ml-1 mt-5" nz-tooltip nzTooltipTitle="Full Screen"></span>-->
                            </div> 
                            <angular-editor formControlName="emailCopy" [config]="editorConfig" maxlength="1000" ></angular-editor>
                            <!-- <span *ngIf="currentUploadedImageSize">Last uploaded image size: {{currentUploadedImageSize}}</span> -->
                    </nz-form-control>
                    <ng-template #emailCopyErr let-control>
                        <ng-container *ngIf="control.hasError('maxlength')">Email Copy should contain maximum 1000 characters</ng-container>
                    </ng-template>
                </div>
                </nz-form-item>
            </div> 
        </div>
    </form>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end ">
            <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoadingOne"
                class="medium-btn small-btn width-100 mr-1">{{selectedUnderReviewData != null ? 'Update' : 'Add'}}</button>
            <button nz-button nzType="default" (click)="handleCancel()"
                class="dlt-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>